import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  input: {
    height: 48,
    '& > div': {
      height: '100%',
      backgroundColor: colors.white,
      '& fieldset': {
        border: `1px solid ${colors.neutral200}`,
      },
      '& input': {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 500,
      },
      '&.Mui-focused , &:hover': {
        '& fieldset': {
          border: `1px solid ${colors.primary} !important`,
        },
      },
    },
  },
});
